import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from 'react';
import { propShape } from '../../../../../../../helpers/custom-prop-types';
const SlideAddFormTableRowFile = (props) => {
    const { input } = props;
    const { value } = input;
    const [fileUrl, changeFileUrl] = useState('');
    useEffect(() => {
        const fileData = value;
        const blob = new Blob([fileData], { type: fileData.type });
        const url = window.URL.createObjectURL(blob);
        changeFileUrl(url);
        return () => {
            window.URL.revokeObjectURL(url);
        };
    }, [value, changeFileUrl]);
    return (_jsx("a", Object.assign({ href: fileUrl, rel: 'noreferrer', target: '_blank' }, { children: value.name })));
};
SlideAddFormTableRowFile.propTypes = {
    input: propShape().isRequired,
};
export default SlideAddFormTableRowFile;
